/**
 * CIO api error formatter
 */

export const API_ERROR_MAP = {
  invalid_credentials: 'The password you entered is invalid.',
};

export default function uiApiFormatter(
  errorCode: keyof typeof API_ERROR_MAP | undefined = undefined,
  variant: string,
  deliveryState: string,
  fallbackText?: string,
) {
  if (!errorCode || !(errorCode in API_ERROR_MAP)) {
    return fallbackText ?? 'Unknown error';
  }

  return API_ERROR_MAP[errorCode];
}
